import { useQuery } from '@tanstack/react-query';
import fetchAPI from '../fetchAPI';

interface Props {
  from?: string | null;
  to?: string | null;
  companyId?: string;
  teamId?: string;
}

export const useEngagementOverTime = ({ from, to, companyId, teamId }: Props) => {
  return useQuery({
    queryKey: ['crm/messages/engagement-over-time', from, to, companyId, teamId],
    queryFn: async () => {
      const queryString = `${from ? `from=${from}` : ``}${to ? `&to=${to}` : ``}${
        companyId ? `&companyId=${companyId}` : ``
      }${teamId ? `&teamId=${teamId}` : ``}`;
      const response: iResponse<EngagementOverTime> = await fetchAPI({
        method: 'GET',
        route: 'crm/messages/engagement-over-time',
        queryString
      });
      return response;
    },
    enabled: !!from && !!to
  });
};

export default useEngagementOverTime;
